<template>
  <div class="content">
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33"
      >
        <chart-card
          :chart-data="dailySalesChart.data"
          :chart-options="dailySalesChart.options"
          :chart-type="'Line'"
          data-background-color="orange"
          v-if="renderComponent"
        >
          <template slot="content">
            <h4 class="title">{{ $t('positions_per_day_title') }}</h4>
            <p class="category">
              <span class="text-success"
                ><i class="fas fa-long-arrow-alt-up"></i> {{ difference }}%
              </span>
              {{ $t('positions_per_day_subtitle') }}
            </p>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon>access_time</md-icon>
              {{ $t('access_time', { min: "0" }) }}
            </div>
          </template>
        </chart-card>
      </div>
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33"
      >
        <chart-card
          :chart-data="revenueInThousandsChart.data"
          :chart-options="revenueInThousandsChart.options"
          :chart-responsive-options="revenueInThousandsChart.responsiveOptions"
          :chart-type="'Bar'"
          data-background-color="purple"
          v-if="renderComponent"
        >
          <template slot="content">
            <h4 class="title">{{ $t('revenue_in_thousands_title') }}</h4>
            <p class="category">
              {{ $t('revenue_in_thousands_subtitle') }}
            </p>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon>access_time</md-icon>
              {{ $t('access_time', { min: "0" }) }}
            </div>
          </template>
        </chart-card>
      </div>
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33"
      >
        <chart-card
          :chart-data="moverNoMoverChart.data"
          :chart-options="moverNoMoverChart.options"
          :chart-type="'Bar'"
          data-background-color="blue"
          v-if="renderComponent"
        >
          <template slot="content">
            <h4 class="title">{{ $t('mover_and_no_mover_title') }}</h4>
            <p class="category">
              {{ $t('mover_and_no_mover_subtitle') }}
            </p>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon>access_time</md-icon>
              {{ $t('access_time', { min: "0" }) }}
            </div>
          </template>
        </chart-card>
      </div>
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25"
      >
        <stats-card data-background-color="green">
          <template slot="header">
            <md-icon>check_circle</md-icon>
          </template>

          <template slot="content">
            <p class="category">System Status</p>
            <h3 class="title">OK</h3>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon>date_range</md-icon>
              {{ $t('status_update_time', { hrs: "24" }) }}
            </div>
          </template>
        </stats-card>
      </div>
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25"
      >
        <stats-card data-background-color="orange">
          <template slot="header">
            <md-icon>hourglass_empty</md-icon>
          </template>

          <template slot="content">
            <p class="category">{{ $t('open_positions_title') }}</p>
            <h3 class="title">
              {{ this.openPositions.length }}
            </h3>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon class="text-danger">warning</md-icon>
              {{ $t('delayed_positions_count', { delayed: this.delayedPositions }) }}
            </div>
          </template>
        </stats-card>
      </div>
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25"
      >
        <stats-card data-background-color="purple">
          <template slot="header">
            <md-icon>payments</md-icon>
          </template>

          <template slot="content">
            <p class="category">{{ $t('revenue_this_month') }}</p>
            <h3 class="title">{{ revenueThisMonth + "€"}}</h3>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon>access_time</md-icon>
              {{ $t('access_time', { min: "0" }) }}
            </div>
          </template>
        </stats-card>
      </div>
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25"
      >
        <stats-card data-background-color="blue">
          <template slot="header">
            <md-icon>more_time</md-icon>
          </template>

          <template slot="content">
            <p class="category">{{ $t('open_optimizations') }}</p>
            <h3 class="title">{{ this.optimizations }}</h3>
          </template>

          <template slot="footer">
            <div class="stats">
              <a href="#/app/kanban-tuner">{{ $t('view_in_kanban_tuner') }}</a>
            </div>
          </template>
        </stats-card>
      </div>
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-75"
      >
        <p-s-table
                tableHeaderColor="orange"
                v-bind:title="$t('open_positions_title')"
                v-bind:subTitle="$t('open_orders_subtitle')"
                height="300"
                showFilter="true"
                sortBy="confirmedDeliveryDate"
                sortOrder="desc"
                v-bind:data="this.openPositions"
                v-bind:dict="this.positionsDict"
        ></p-s-table>
      </div>
    </div>
  </div>
</template>

<script>
import {
  StatsCard,
  ChartCard,
  PSTable
} from "@/components";
import api from "@/api/api";
import store from '@/store/index.js';

function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

export default {
  components: {
    StatsCard,
    ChartCard,
    PSTable
  },
  data() {
    return {
      optimizations: 0,
      shownWelcomeMessage: false,
      renderComponent: true,
      openPositions: [],
      positionsDict: [
        { key: 'order', label: 'table_header_order', type: 'string'},
        { key: 'articleNumber', label: 'table_header_customer_article_number_short', type: 'string'},
        { key: 'articleDescription', label: 'table_header_customer_article_description', type: 'string'},
        { key: 'supplier', label: 'table_header_supplier', type: 'string'},
        { key: 'supplierArticleNumber', label: 'table_header_supplier_article_number', type: 'string'},
        { key: 'confirmedDeliveryDate', label: 'table_header_delivery_date', type: 'date'},
      ],
      loaded: false,
      dict: [],
      systemStatus: true,
      revenueThisMonth: 0,
      difference: 0,
      delayedPositions: 0,
      dailySalesChart: {
        data: {
        },
        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 0
          }),
          low: 0,
          high: 50,
          chartPadding: {
            top: 20,
            right: 0,
            bottom: 0,
            left: 0
          }
        }
      },
      moverNoMoverChart: {
        data: {
          labels: ["0", "1-5", "5-12", ">12"],
        },
        options: {
          axisX: {
            showGrid: false
          },
          low: 0,
          high: 3000,
          chartPadding: {
            top: 20,
            right: 0,
            bottom: 0,
            left: 10
          }
        }
      },
      revenueInThousandsChart: {
        data: {
        },
        options: {
          axisX: {
            showGrid: false
          },
          low: 0,
          high: 100000,
          chartPadding: {
            top: 20,
            right: 5,
            bottom: 0,
            left: 30
          }
        },
        responsiveOptions: [
          [
            "screen and (max-width: 640px)",
            {
              seriesBarDistance: 5,
              axisX: {
                labelInterpolationFnc: function(value) {
                  return value[0];
                }
              }
            }
          ]
        ]
      }
    };
  },
  created() {
    store.commit("setLoading", true);

    api.getOpenPositions().then((result) => {
      this.openPositions = result.data;

      store.commit("setLoading", false);
    });

    api.getSystemStatus().then((result) => {
      this.systemStatus = result.data;
    });

    api.getOpenOptimizationsCount().then((result) => {
      this.optimizations = result.data[0].count;
    });

    api.getDelayedPositions().then((result) => {
        this.delayedPositions = result.data.delayedpositions;
    });

    let days = ['Su','Mo','Tu','We','Th','Fr','Sa'];

    api.getPositionsPerDay().then((result) => {
      result.data = result.data.reverse();
      this.renderComponent = false;

      let array = [];
      let labels = [];

      for (let i = 0; i < result.data.length; i++) {
        array.push(parseInt(result.data[i].positionperday));
        labels.push(days[new Date(result.data[i].day).getDay()]);
      }

      let max = Math.max.apply(null, array);
      max = max * 10 / 9;
      this.dailySalesChart.options.high = Math.max(max, 4);
      this.dailySalesChart.data.series = [array];
      this.dailySalesChart.data.labels = labels;

      let diff = array[6] - array[5];

      if (array[5] === 0 && diff !== 0) {
        this.difference = 100;
      } else if (array[6] === 0 && diff !== 0) {
        this.difference = -100;
      } else if (diff !== 0) {
        this.difference = (diff / array[6] * 100).toFixed(0);
      }

      this.$nextTick(() => {
        this.renderComponent = true;
      });
    });

    api.getRevenueYear().then((result) => {
      this.renderComponent = false;
      this.revenueThisMonth = numberWithCommas(result.data[result.data.length - 1].revenue.toString().replace(".", ","));

      let months = [ "Ja", "Fe", "Ma", "Ap", "Mai", "Ju", "Jul", "Au", "Se", "Oc", "No", "De" ];

      let revenues = [];
      let dates = [];

      for (let i = 0; i < result.data.length; i++) {
        dates.push(months[result.data[i].month - 1]);
        revenues.push(result.data[i].revenue);
      }

      let max = Math.max.apply(null, revenues);
      max = max * 11 / 9;
      this.revenueInThousandsChart.options.high = Math.max(max, 4);
      this.revenueInThousandsChart.data.series = [revenues];
      this.revenueInThousandsChart.data.labels = dates;

      this.$nextTick(() => {
        this.renderComponent = true;
      });
    });

    api.getMoverNoMover().then((result) => {
      let moverNoMover = result.data[0];
      this.renderComponent = false;

      let max = Math.max(moverNoMover.count0, moverNoMover.count1to5, moverNoMover.count6to12, moverNoMover.count12);
      max = max * 11 / 9;
      this.moverNoMoverChart.options.high = Math.max(max, 3);
      this.moverNoMoverChart.data.series = [[moverNoMover.count0, moverNoMover.count1to5, moverNoMover.count6to12, moverNoMover.count12]];

      this.$nextTick(() => {
        this.renderComponent = true;
      });
    });

    if (localStorage.getItem('once') === null) {
      this.$notify(
          {
            message: this.$t('first_login_notification'),
            icon: 'info',
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'primary',
            timeout: 5000
          });

      localStorage.setItem("once", true);
    }
  }
};
</script>
